// extracted by mini-css-extract-plugin
export default {"modalBody":"modalBody-zj55A","charts":"charts-RfrtF"};